import { EPageMode, IPageState } from '../../types/features';
import { TReduxActions } from '../../types/redux';

export const initialState: IPageState = {
  mode: EPageMode.Auth,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function pageReducer(state: IPageState = initialState, { type, payload }: TReduxActions) {
  return state;
}
